import { takeLatest, put } from 'redux-saga/effects';
import get from 'lodash/get';

import { consts as declineInvitationConsts } from '../declineInvitation';
import { consts as acceptInvitationConsts } from '../acceptInvitation';
import { consts as reqCommunityInfoConsts } from '../currentCommunityInfo';
import { consts as reqCommunitiesConsts } from '../reqDiscoverCommunities';
import { consts as reqJoinCommunityConsts } from '../reqJoinCommunity';

function* updateCurrentCommunityWorker({ payload }) {
  const community = get(payload, 'community') || payload;

  yield put({
    type: reqCommunitiesConsts.UPDATE_COMMUNITY,
    payload: community,
  });

  yield put({
    type: reqCommunityInfoConsts.UPDATE_CURRENT_COMMUNITY,
    payload: community,
  });
}

export default function* updateCurrentCommunitySaga() {
  yield takeLatest(
    [
      declineInvitationConsts.SUCCEED,
      acceptInvitationConsts.SUCCEED,
      reqJoinCommunityConsts.SUCCEED,
    ],
    updateCurrentCommunityWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/communities/sagas/updateCurrentCommunity.js